module.exports = __webpack_public_path__ + "img/celebrate.8db5efdb.gif";